import React from 'react'
import { compose } from 'recompose'
import { Radio } from 'semantic-ui-react'

const SwitchInput = (props) => {
  const { label, input, style, fieldInputStyle={}, horizontalView, editable, options = [], specialOnChange, require, meta: { touched, error } } = props
  return (
    <div className='fieldRow' style={{...style}}>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className={`fieldInput ${horizontalView===true?'radioV':''}`} style={{...fieldInputStyle}}>
        {
          options.map(o => 
            <Radio 
              name={input.name}
              disabled={editable === false}
              label={o.text}
              value={o.value}
              checked={input.value === o.value}
              onChange={() => {
                input.onChange(o.value)
                if (specialOnChange) specialOnChange(o.value)
              }}
            />
          )
        }
      </div>
    </div>
  )
}

export default compose()(SwitchInput)